import React, { Component } from 'react'
import './Mag.css';

import img1 from '../assets/issue_6/rm_06-01.png'
import img2 from '../assets/issue_6/rm_06-02.png'
import img3 from '../assets/issue_6/rm_06-03.png'
import img4 from '../assets/issue_6/rm_06-04.png'
import img5 from '../assets/issue_6/rm_06-05.png'
import img6 from '../assets/issue_6/rm_06-06.png'
import img7 from '../assets/issue_6/rm_06-07.png'
import img8 from '../assets/issue_6/rm_06-08.png'
import img9 from '../assets/issue_6/rm_06-09.png'
import img10 from '../assets/issue_6/rm_06-10.png'
import img11 from '../assets/issue_6/rm_06-11.png'
import img12 from '../assets/issue_6/rm_06-12.png'
import img13 from '../assets/issue_6/rm_06-13.png'
import img14 from '../assets/issue_6/rm_06-14.png'
import img15 from '../assets/issue_6/rm_06-15.png'
import img16 from '../assets/issue_6/rm_06-16.png'
import img17 from '../assets/issue_6/rm_06-17.png'
import img18 from '../assets/issue_6/rm_06-18.png'
import img19 from '../assets/issue_6/rm_06-19.png'
import img20 from '../assets/issue_6/rm_06-20.png'
import img21 from '../assets/issue_6/rm_06-21.png'
import img22 from '../assets/issue_6/rm_06-22.png'
import img23 from '../assets/issue_6/rm_06-23.png'
import img24 from '../assets/issue_6/rm_06-24.png'
import img25 from '../assets/issue_6/rm_06-25.png'
import img26 from '../assets/issue_6/rm_06-26.png'
import img27 from '../assets/issue_6/rm_06-27.png'
import img28 from '../assets/issue_6/rm_06-28.png'
import img29 from '../assets/issue_6/rm_06-29.png'
import img30 from '../assets/issue_6/rm_06-30.png'
import img31 from '../assets/issue_6/rm_06-31.png'
import img32 from '../assets/issue_6/rm_06-32.png'
import img33 from '../assets/issue_6/rm_06-33.png'
import img34 from '../assets/issue_6/rm_06-34.png'
import img35 from '../assets/issue_6/rm_06-35.png'
import img36 from '../assets/issue_6/rm_06-36.png'
import img37 from '../assets/issue_6/rm_06-37.png'
import img38 from '../assets/issue_6/rm_06-38.png'
import img39 from '../assets/issue_6/rm_06-39.png'
import img40 from '../assets/issue_6/rm_06-40.png'

export default class Mag006 extends Component {
  render() {
    return (
      <div className="image-container">
        <img src={img1} className="image"></img>
        <img src={img2} className="image"></img>
        <img src={img3} className="image"></img>
        <img src={img4} className="image"></img>
        <img src={img5} className="image"></img>
        <img src={img6} className="image"></img>
        <img src={img7} className="image"></img>
        <img src={img8} className="image"></img>
        <img src={img9} className="image"></img>
        <img src={img10} className="image"></img>
        <img src={img11} className="image"></img>
        <img src={img12} className="image"></img>
        <img src={img13} className="image"></img>
        <img src={img14} className="image"></img>
        <img src={img15} className="image"></img>
        <img src={img16} className="image"></img>
        <img src={img17} className="image"></img>
        <img src={img18} className="image"></img>
        <img src={img20} className="image"></img>
        <img src={img21} className="image"></img>
        <img src={img22} className="image"></img>
        <img src={img23} className="image"></img>
        <img src={img24} className="image"></img>
        <img src={img25} className="image"></img>
        <img src={img26} className="image"></img>
        <img src={img27} className="image"></img>
        <img src={img28} className="image"></img>
        <img src={img29} className="image"></img>
        <img src={img30} className="image"></img>
        <img src={img31} className="image"></img>
        <img src={img32} className="image"></img>
        <img src={img33} className="image"></img>
        <img src={img34} className="image"></img>
        <img src={img35} className="image"></img>
        <img src={img36} className="image"></img>
        <img src={img37} className="image"></img>
        <img src={img38} className="image"></img>
        <img src={img39} className="image"></img>
        <img src={img40} className="image"></img>
      </div>
    )
  }
}
